module.exports = __webpack_public_path__ + "img/roquette2.5067b9b7.jpeg";